import { Navigate, Outlet } from 'react-router-dom';
import DesignerSidebar from './DesignerSidebar';
import { useBrandContext } from 'context/BrandProvider';
import clsx from 'clsx';
import { useState } from 'react';
import { defaultBrand } from 'api/brand/utils';
import { getBrand } from 'api/brand/api';
import { useQuery } from 'react-query';
import { PageLoader } from 'components/PageLoader';
import { usePermissions } from 'hooks/usePermissions';
import { TokenUserPermissions } from 'api/users/schemas/Users';

const ThemeDesignerLayout = () => {
  const { onUpdateBrand } = useBrandContext();
  const [loading, setLoading] = useState(true);

  const { data, error } = useQuery(['brand'], () => getBrand(), {
    onSuccess: (data) => {
      setTimeout(() => onUpdateBrand(data?.config_data ?? defaultBrand), 500);
    },
    onSettled: () => {
      setLoading(false);
    },
    refetchOnWindowFocus: false,
  });

  const { hasPermission } = usePermissions({
    forGraniteUser: true,
    permission: [
      TokenUserPermissions.WHITELABEL_MANAGE,
      TokenUserPermissions.WHITELABEL_READ,
      TokenUserPermissions.WHITELABEL_WRITE,
    ],
  });

  if (!hasPermission) return <Navigate to="/" />;

  if (loading && !error) return <PageLoader />;

  return (
    <div className="flex h-screen w-full">
      <DesignerSidebar
        data={data?.config_data ?? defaultBrand}
        brandId={data?.id}
      />
      <div
        className={clsx(
          'h-full w-full bg-background-base-surface-1 duration-500',
          {
            'opacity-0': loading,
            'opacity-100': !loading,
          },
        )}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default ThemeDesignerLayout;
